import { render } from "./promocioneshabitaciones.vue?vue&type=template&id=1359d45c&scoped=true"
import script from "./promocioneshabitaciones.vue?vue&type=script&lang=js"
export * from "./promocioneshabitaciones.vue?vue&type=script&lang=js"

import "./promocioneshabitaciones.vue?vue&type=style&index=0&id=1359d45c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1359d45c"]])

export default __exports__